import { State } from '../../../reducers/State';
import { State as ControlsState } from '../../../reducers/CommentHistory/Controls';
import { createSelector } from 'reselect';
import { DateRange, CommentType, SortBy } from 'models/CommentHistory';
import { Severity } from 'Common/components/Molecules/CommentSeverityIcon';

export const controlsSelector = (state: State): ControlsState => {
  return state.commentHistory.controls;
};

export function getCurrentOrganizationUUID(
  controls: ControlsState
): string | undefined {
  return controls.organizationUUID;
}

export const currentOrganizationUUIDSelector = createSelector(
  controlsSelector,
  getCurrentOrganizationUUID
);

export function getDateRange(controls: ControlsState): DateRange {
  return controls.dateRange;
}

export const dateRangeSelector = createSelector(controlsSelector, getDateRange);

export function getCommentType(controls: ControlsState): CommentType {
  return controls.commentType;
}

export const commentTypeSelector = createSelector(
  controlsSelector,
  getCommentType
);

export function isSeverityVisible(controls: ControlsState): boolean {
  return controls.commentType === 'inline';
}

export const isSeverityVisibleSelector = createSelector(
  controlsSelector,
  isSeverityVisible
);

export function getSeverity(controls: ControlsState): Severity | undefined {
  return controls.severity;
}

export const severitySelector = createSelector(controlsSelector, getSeverity);

export function isCategoryVisible(controls: ControlsState): boolean {
  return controls.commentType === 'inline';
}

export const isCategoryVisibleSelector = createSelector(
  controlsSelector,
  isCategoryVisible
);

export function getCategory(controls: ControlsState): string | undefined {
  return controls.category;
}

export const categorySelector = createSelector(controlsSelector, getCategory);

export function isInitialFilters(controls: ControlsState): boolean {
  return (
    controls.commentType === 'inline' &&
    controls.severity === undefined &&
    controls.category === undefined &&
    controls.author === undefined &&
    controls.repositoryUUID === undefined
  );
}

export const isInitialFiltersSelector = createSelector(
  controlsSelector,
  isInitialFilters
);

export function getSortBy(controls: ControlsState): SortBy {
  return controls.sortBy;
}

export const sortBySelector = createSelector(controlsSelector, getSortBy);

export function getPage(controls: ControlsState) {
  return controls.page;
}

export const pageSelector = createSelector(controlsSelector, getPage);
